import {IMultiLanguageString} from './i-multi-language-string';

export class MultiLanguageString {
    public constructor(public nl?: string, public fr?: string, public en?: string, public de?: string) {
    }

    public static fromInterface(iMultiLanguageString?: IMultiLanguageString): MultiLanguageString {
        return new MultiLanguageString(iMultiLanguageString?.nl, iMultiLanguageString?.fr,
            iMultiLanguageString?.en, iMultiLanguageString?.de);
    }
}
